"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCESS_DESIGN_MODE = void 0;
var ACCESS_DESIGN_MODE;
(function (ACCESS_DESIGN_MODE) {
    ACCESS_DESIGN_MODE["EDIT"] = "EDIT";
    ACCESS_DESIGN_MODE["READONLY"] = "READONLY";
})(ACCESS_DESIGN_MODE || (exports.ACCESS_DESIGN_MODE = ACCESS_DESIGN_MODE = {}));
